import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../css/Alfresco.css';

function Alfresco() {
  const [carpetas, setCarpetas] = useState(null);
  const [carpetaActual, setCarpetaActual] = useState(null);
  const [nuevaCarpetaNombre, setNuevaCarpetaNombre] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);

  // const datosAcceso = JSON.parse(localStorage.getItem('datosAcceso'));
  // console.log(datosAcceso);

  useEffect(() => {
    listarCarpetas();
  }, []);

  async function listarCarpetas(carpetaId) {
    try {
      const datosAcceso = JSON.parse(localStorage.getItem('datosAcceso'));
      const url = carpetaId
        ? `${process.env.REACT_APP_BACKEND_URL}/alfresco/carpetas/${carpetaId}`
        : `${process.env.REACT_APP_BACKEND_URL}/alfresco/carpetas`;
  
      const response = await axios.get(url, {
        headers: {
          'x-auth-email': datosAcceso.email,
          'x-auth-password': datosAcceso.contrasena
        }
      });
      setCarpetas(response.data.list.entries);
      setCarpetaActual(carpetaId);
  
    } catch (error) {
      console.error('Error al obtener las carpetas:', error);
    }
  }
  
  
  async function crearSubcarpeta() {
    if (nuevaCarpetaNombre.trim() !== '') {
      try {
        const datosAcceso = JSON.parse(localStorage.getItem('datosAcceso'));
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/alfresco/crear/${carpetaActual}/${encodeURIComponent(nuevaCarpetaNombre)}`,
          {},
          {
            timeout: 0,
            headers: {
              'x-auth-email': datosAcceso.email,
              'x-auth-password': datosAcceso.contrasena
            }
          }
        );
  
        console.log('Carpeta creada:', response.data);
        listarCarpetas(carpetaActual); // Actualizar la lista de carpetas
  
        setNuevaCarpetaNombre(''); // Limpiar el campo de nombre
      } catch (error) {
        console.error('Error al crear la subcarpeta:', error);
      }
    }
  }
  
  async function subirArchivo() {
    if (selectedFile) {
      console.log('Archivo seleccionado:', selectedFile);
  
      try {
        const datosAcceso = JSON.parse(localStorage.getItem('datosAcceso'));
        const formData = new FormData();
        formData.append('file', selectedFile);
  
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/alfresco/subir/${carpetaActual}`,
          formData, // Enviar el FormData con el archivo
          {
            headers: {
              'x-auth-email': datosAcceso.email, // Enviar credenciales en los encabezados personalizados
              'x-auth-password': datosAcceso.contrasena
            }
          }
        );
        
        // Después de subir el archivo, actualiza la lista de carpetas
        listarCarpetas(carpetaActual);
  
        // Actualiza selectedFile a null después de subir el archivo
        setSelectedFile(null);
        console.log('Archivo subido:', response.data);
        // Actualiza la lista de archivos si es necesario
      } catch (error) {
        console.error('Error al subir el archivo:', error);
      }
    } else {
      console.log('No se seleccionó ningún archivo');
    }
}


  function cerrarVentana() {
    window.close();
  }

  return (
    <div className="alfresco-container">
      <div className="buttons">
        <button onClick={() => listarCarpetas()}>Carpeta raíz</button>
      </div>
      {Array.isArray(carpetas) ? (
        <ul className="items-list">
          {carpetas.map((item) => (
            <li
              key={item.entry.id}
              className={item.entry.isFolder ? 'folder' : 'file'}
              onClick={() => {
                if (item.entry.isFolder) {
                  listarCarpetas(item.entry.id);
                }
              }}
            >
              <span className="icon">{item.entry.isFolder ? '📁' : '📄'}</span>
              {item.entry.name}
            </li>
          ))}
        </ul>
      ) : (
        <p>Cargando carpetas...</p>
      )}

      {carpetaActual && (
        <div className="actions">
          <div className='divCrear'>
          <input
            type="text"
            value={nuevaCarpetaNombre}
            onChange={(e) => setNuevaCarpetaNombre(e.target.value)}
            placeholder="Nombre de la nueva carpeta"
          />
          <button onClick={crearSubcarpeta}>Crear Subcarpeta</button>
          </div>
          <div className='divSubir'>
          <input type="file" onChange={(e) => setSelectedFile(e.target.files[0])} />
          <button onClick={subirArchivo}>Subir Archivo</button>
          </div>
          <button onClick={cerrarVentana}>Cerrar ventana</button>
        </div>
        
      )}
    </div>
  );
}

export default Alfresco;